import EliminatedPath from 'app/assets/ppm/16/PPM_LifecycleStage_Eliminated_16.png';
import GrowthPath from 'app/assets/ppm/16/PPM_LifecycleStage_Growth_16.png';
import IntroductionPath from 'app/assets/ppm/16/PPM_LifecycleStage_Introduction_16.png';
import NotAvailablePath from 'app/assets/ppm/16/PPM_LifecycleStage_NotAvailable_16.png';
import NotUsedInCountryPath from 'app/assets/ppm/16/PPM_LifecycleStage_NotUsedInCountry_16.png';
import OccasionalUsePath from 'app/assets/ppm/16/PPM_LifecycleStage_OccasionalUse_16.png';
import PhaseOutPath from 'app/assets/ppm/16/PPM_LifecycleStage_PhaseOut_16.png';
import UndefinedPath from 'app/assets/ppm/16/PPM_LifecycleStage_Undefined_16.png';

export const ppmIconSmall = {
    E: EliminatedPath,
    G: GrowthPath,
    I: IntroductionPath,
    NA: NotAvailablePath,
    N: NotUsedInCountryPath,
    O: OccasionalUsePath,
    P: PhaseOutPath,
    U: UndefinedPath
};
